import * as axios from "axios";
import CONSTANT from "./../constant";
import {
  getAuthHeader,
  getSuperUserAuthHeader,
  setCookie,
  setStorage,
} from "./../utils";
import { updateHrDealingOfficer } from "./UserAction";
export const loginAs = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/login-as`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      if (response.data.error === null) {
        setCookie(CONSTANT.cookie.token, response.data.result.token);
        setCookie(CONSTANT.cookie.userDetail, response.data.result.userDetail);
        setStorage(CONSTANT.cookie.recipients, response.data.result.recipients);
        setStorage(
          CONSTANT.cookie.permissions,
          response.data.result.permissions
        );
      }
      return response.data;
    },
    (error: any) => {
      return { status: false, error: error.message };
    }
  );
};

export const checkActiveSession = (model: any) => {
  try {
    let url = `${process.env.REACT_APP_BASE_URL}auth/active-session`;
    return axios.post(url, model).then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.message);
      }
    );
  } catch (err) {
    return err;
  }
};

export const checkActiveSessionMobile = (model: any) => {
  try {
    let url = `${process.env.REACT_APP_BASE_URL}auth/active-session-mob`;
    return axios.post(url, model).then(
      (response: any) => {
        return response.data;
      },
      (error: any) => {
        alert(error.message);
      }
    );
  } catch (err) {
    return err;
  }
};

export const login = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/login`;
  return axios.post(url, model).then(
    (response: any) => {
      if (response.data.error === null) {
        if (!response.data.result.showPwdUpdateMsg) {
          // setCookie(CONSTANT.cookie.token, response.data.result.token);
          // setCookie(
          //   CONSTANT.cookie.userDetail,
          //   response.data.result.userDetail
          // );
          // setStorage(
          //   CONSTANT.cookie.recipients,
          //   response.data.result.recipients
          // );
          // setStorage(
          //   CONSTANT.cookie.permissions,
          //   response.data.result.permissions
          // );
          // updateHrDealingOfficer().then((res: any) => {
          //   if (res.status === CONSTANT.static.apiStatus.success) {
          //   } else {
          //     alert(res.error);
          //   }
          // });
        }
      }
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const crossAppSession = (token: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/cross-app-session`;
  return axios.post(url, { token }).then(
    (response: any) => response.data,
    () => null
  );
};

export const updateUser = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/update`;
  return axios.put(url, model).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const LoggiedInAuthValidate = (userCode: Number) => {
  const url = `${process.env.REACT_APP_BASE_URL}loggedin/user/auth?userCode=${userCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const removeSessionHistoryData = (userCode: Number) => {
  const url = `${process.env.REACT_APP_BASE_URL}remove/session/history?userCode=${userCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const restartLoggedInUserSession = (userCode: Number) => {
  const url = `${process.env.REACT_APP_BASE_URL}restart/loggedin/user/session?userCode=${userCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const getUserList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/list`;
  return axios.get(url).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const getUserDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/detail/${code}`;
  return axios.get(url).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};
export const updatePassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/password`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};
export const forgotPassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/forgot-password`;
  return axios.post(url, model).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};
export const resetPassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/reset-password`;
  return axios.post(url, model).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const adminResetPassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/admin-reset-password`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const superUserLogin = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}super-user-login`;
  return axios.post(url, model).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const activeSessionusersList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}get-all-active-users`;
  return axios.get(url, getSuperUserAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const removeActiveSession = (userCode: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}delete-active-session?userCode=${userCode}`;
  return axios.get(url, getSuperUserAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const LoginwithMobile = (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/login-with-mob`;
  return axios.post(url, data).then((res: any) => {
    return res.data;
  });
};

export const FileSendOpt = (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/file-opt`;
  return axios.post(url, data).then((res: any) => {
    return res.data;
  });
};

export const LoginMobileOtpVerify = (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/login-otp-verify`;
  return axios.post(url, data).then((res: any) => {
    return res.data;
  });
};

export const fileOtpVerify = (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}auth/file-otp-verify`;
  return axios.post(url, data).then((res: any) => {
    return res.data;
  });
};
